import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-803",
  "use": "icon-803-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-803\" viewBox=\"0 0 16 16\" id=\"icon-803\">\n  <path d=\"M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 15a6.73 6.73 0 0 1-.948-.072.486.486 0 0 1-.24-.106A8.838 8.838 0 0 1 3.962 8 8.868 8.868 0 0 1 6.76 1.22a.702.702 0 0 1 .359-.157A6.613 6.613 0 0 1 8 1a7 7 0 0 1 0 14z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol